var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('s-location',{attrs:{"mypage":"","title":"원격지원"}}),_c('h4',{staticClass:"sub_title02"},[_vm._v("원격지원")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }